<section>
  <app-form-header></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (showRecipients && recipients.length) {
        <section class="astral-section-surface astral-stack-s">
          <h4>{{ 'MULTI_TENANT_FORM.RECIPIENT_HEADER' | translate }}</h4>
          <div class="astral-chip-list">
            @for (recipient of recipients; track recipient; let i = $index) {
              <astral-chip
                [label]="recipient.recipientName"
                [removable]="recipients.length > 1"
                removeAriaLabelKey="COMMON.REMOVE"
                (remove)="removeRecipient(recipient, i)"
              ></astral-chip>
            }
          </div>
        </section>
      }
      <section class="astral-section-surface astral-form-stack">
        <astral-input [control]="form.controls['subject']"></astral-input>
        <astral-textarea [control]="form.controls['body']" [rows]="20"></astral-textarea>
        <app-file-upload [forms]="form.controls['attachments']" buttonVariant="primary"></app-file-upload>
      </section>
      <div class="astral-form-actions">
        <astral-button type="button" variant="primary" labelKey="SEND_BTN" [disabled]="form.invalid || form.disabled" (click)="onSubmit()"></astral-button>
        <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      </div>
    </form>
  }
</section>
